import { Button, Stack, Box, Typography, Avatar } from "@mui/material";
import ProfileAvatar from "components/base/ProfileAvatar";
import PeopleIcon from "@mui/icons-material/People";

export default function UserListItem({ 
  user, 
  onRemove, 
  loading = false,
  hideButton = false,
}) {
  const isDistributionList = user.sharedWithTypeId === 2 || user.isDistributionList === true;
  
  const displayName = user.userName || user.username || null;
  // Sources that carry no display name (archived snapshots) fall back to the email;
  // showing it again underneath would just repeat the same string.
  const primaryLabel = displayName || user.email;
  const showEmailLine = Boolean(user.email) && user.email !== primaryLabel;

  const isInvited = Boolean(
    (user.userId || (user.id && !String(user.id).startsWith("email-"))) && 
    user.isConfirmed !== false
  );

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      sx={{ mb: 2 }}
    >
      <Box sx={{ display: "flex", gap: 1 }}>
          <Stack gap={1.2} flexDirection="row" alignItems={isDistributionList ? "center" : "start"}>
            {isDistributionList ? (
              <Avatar sx={{ 
                width: "2.5rem", 
                height: "2.5rem",
                bgcolor: "primary.main"
              }}>
                <PeopleIcon sx={{ fontSize: "2rem" }} />
              </Avatar>
            ) : (
              <ProfileAvatar
                userId={user.userId}
                avatarUrl={user.userAvatar}
              />
            )}
            <Stack direction={"column"} gap={0} sx={{ justifyContent: isDistributionList ? "center" : "flex-start" }}>
              <Typography variant="body1" sx={{ fontSize: "1.6rem" }}>
                {isDistributionList 
                  ? user.distributionListName || user.generatedDistributionListName
                  : primaryLabel
                }
              </Typography>
              {!isDistributionList && showEmailLine && (
              <Typography
                variant="body2"
                sx={{
                  color: "grey.600",
                  fontSize: "1.3rem",
                }}
              >
                {user.email}
              </Typography>
          )}            
          </Stack>
        </Stack>
      </Box>
      <Button 
        variant="outlined" 
        onClick={() => onRemove(user)}
        disabled={loading || hideButton}
      >
        {isInvited ? "Remove" : "Uninvite"}
      </Button>
    </Stack>
  );
}
